import React from "react";

export interface SnowGlobeProps {}

const SnowGlobe: React.FC<SnowGlobeProps> = () => {
	return (
		<div className="snowglobe">
			<div className="sg-bg"></div>
			<div className="grnd-snow">
				<div className="snow-surface"></div>
			</div>
			<div className="tree">
				<div className="tree-shadow"></div>
				<div className="branch-bot">
					<div className="branch-bot-snow"></div>
					<div className="branch-shadow"> </div>
				</div>
				<div className="branch-mid">
					<div className="branch-mid-snow"></div>
					<div className="branch-shadow"> </div>
				</div>
				<div className="branch-top">
					<div className="branch-top-snow"></div>
				</div>
				<div className="star"></div>
				<div className="baubles"></div>
			</div>
			<div className="sm-shadow"></div>
			<div className="snowman">
				<div className="snowman-bot"></div>
				<div className="snowman-top"></div>
				<div className="coal"></div>
				<div className="carrot"></div>
			</div>
			<div className="falling-snow-wrap">
				<div className="falling-snow">
					<div className="flakes1">
						<p>*</p>
					</div>
					<div className="flakes2">
						<p>*</p>
					</div>
				</div>
			</div>
			<div className="sg-fg"></div>
			<div className="stand-curved-wrap">
				<div className="stand-curved"></div>
			</div>
		</div>
	);
};

export default SnowGlobe;
